export default "__VITE_ASSET__RHqQNNnl__"